import React from "react"
import styled from "styled-components"

import { theme, sectionFull, DesktopOnly, PhoneOnly } from "@/common/Mixin"
import { Swiper, SwiperSlide } from "swiper/react"
import "swiper/css"
import "swiper/css/pagination"
import { Pagination, Autoplay } from "swiper/modules"
import BlogCard, { BlogCardProps } from "./BlogCard"
import ProductHeading from "./_UI/ProductHeading"

interface ShowCaseProps {
  id?: string
  title?: string
  data: BlogCardProps[]
}

export default function ShowCase({ title, id, data }: ShowCaseProps) {
  return (
    <Wrapper id={id} className="kg-wrapper">
      {title && <ProductHeading as="h3" content={title} />}
      <DesktopOnly>
        <SliderWrapper>
          <Swiper
            slidesPerView={1.2}
            centeredSlides={true}
            spaceBetween="10%"
            className="mySwiper"
            initialSlide={0}
            modules={[Pagination, Autoplay]}
            autoplay={{
              delay: 5000,
              disableOnInteraction: false
            }}
            pagination={{
              clickable: true
            }}
            loop={true}
            speed={500}
            breakpoints={{
              1280: {
                slidesPerView: 2,
                spaceBetween: "5%"
              }
            }}
          >
            {data.map((props, index) => (
              <SwiperSlide key={`${props.title}_${index}`}>
                <BlogCard {...props} />
              </SwiperSlide>
            ))}
          </Swiper>
        </SliderWrapper>
      </DesktopOnly>
      <PhoneOnly>
        <CardsWrapper>
          {data.map(props => (
            <BlogCard key={props.title} {...props} />
          ))}
        </CardsWrapper>
      </PhoneOnly>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  ${sectionFull}
  overflow: hidden;
  display: flex;
  flex-direction: column;
  gap: var(--cardGap);
`
const SliderWrapper = styled.div`
  width: 100%;
  .swiper {
    border-radius: 40px;
    padding: 10px 30px 60px 30px;
    overflow: visible;
    @media (${theme.md}) {
    }
  }
  .swiper-wrapper {
    /* transition-timing-function: linear; */
  }
  .swiper-pagination.swiper-pagination-clickable.swiper-pagination-bullets.swiper-pagination-horizontal {
    display: flex;
    gap: 24px;
    margin: 0 auto;
    justify-content: center;
  }
  .swiper-pagination-bullet {
    width: 12px;
    height: 12px;
    opacity: 1;
    background: #858585;
  }
  .swiper-pagination-bullet-active {
    background: ${theme.color.primary};
  }

  .swiper {
    width: 100%;
    height: 100%;
  }

  .swiper-slide {
    text-align: center;
    font-size: 18px;

    /* Center slide text vertically */
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .swiper-slide {
    width: auto;
    transition: all 0.3s;
    opacity: 0.8;
    &.swiper-slide-active {
      transform: scale(1.05);
      opacity: 1;
    }

    &:hover {
      opacity: 1;
    }
  }
`

const CardsWrapper = styled.a`
  display: grid;
  grid-template-columns: 1fr;
  gap: var(--cardGap);
  padding: 0 var(--paddingX);
`
